import { ReactNode } from 'react';

import { IBeneficiary } from '@/features/beneficiaries/store/models/beneficiary.model';

const headers = ['name', 'sepaCreditorIdentifier', 'iban', 'isActive', 'userId', 'bic', 'createdDate'] as const;

type THeadersKeys = (typeof headers)[number];
export type TAllBeneficiaryRowType = {
  [key in keyof Pick<IBeneficiary, THeadersKeys> | 'actions']: ReactNode;
};

export const allBeneficiaryHeadersList: (keyof TAllBeneficiaryRowType)[] = [...headers, 'actions'] as const;
